<div *ngIf="user">
    <div class="modal-header" [ngClass]="isError ? 'red-important' : ''">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="mr-3 ml-2" style="width: 30px;" src='assets/ico/jira-icon-white.svg' alt="icon" />
                    <span class="modal-title" id="modal-basic-title" *ngIf="!isError">
                        <span *ngIf="user.jiraUser.syncStatus === 'ADDED'"> {{'jiraUsers.success' | translate }} </span>
                        <span *ngIf="user.jiraUser.syncStatus === 'NOT_MODIFIED'"> {{'jiraUsers.nodModified' | translate
                            }} </span>
                        <span *ngIf="user.jiraUser.syncStatus === 'UPDATED'"> {{'jiraUsers.updated' | translate }}
                        </span>
                    </span>
                    <span class="modal-title" id="modal-basic-title" *ngIf="isError">
                        Error while activating {{email}} on Jira
                    </span>

                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="row m-0 mb-3 pl-5 pr-5 pt-2">
            <div class="col-lg-12 p-0 mb-3">
                <ul *ngIf="user && user.actions && user.actions.length > 1"
                    style="margin-left: -20px; margin-bottom: 0px;">
                    <li *ngFor="let action of user.actions">
                        {{action}}
                    </li>
                </ul>
                <div *ngIf="user && user.actions && user.actions.length == 1">
                    {{user.actions[0]}}
                </div>
                <div *ngIf="user.jiraUser" class="mt-3">
                    <span *ngIf="user.jiraUser  && user.jiraUser.syncStatus">Jira Sync Status:
                        <strong>{{user.jiraUser.syncStatus}}</strong><br /></span>
                    <span *ngIf="user.jiraUser  && user.jiraUser.key">User Key:
                        <strong>{{user.jiraUser.key}}</strong><br /></span>
                    <span *ngIf="user.jiraUser  && user.jiraUser.name">User Name:
                        <strong>{{user.jiraUser.name}}</strong><br /></span>
                </div>
                <div class="mt-3"
                    *ngIf="user.jiraUserGroupResponse && user.jiraUserGroupResponse.jiraGroup && user.jiraUserGroupResponse.jiraGroup.length > 0">
                    <div style="font-size: 20px; font-weight: 800; font-style: italic; margin-bottom: 10px; padding-top: 15px;">Applications</div>
                    <ng-template ngFor let-item [ngForOf]="user.jiraUserGroupResponse.jiraGroup" let-i="index">
                        <div class="group-label">{{item.label}}</div>
                        <ul *ngIf="item.groups.length > 0">
                            <li *ngFor="let item of item.groups"><span style="font-style: italic;">{{item.groupName}}:</span>&nbsp;{{item.action}} </li>
                        </ul>
                    </ng-template>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <span class="btn modal-btn save back" (click)="close()">{{'jiraUsers.done' | translate }}</span>
            <a *ngIf="user.jiraUser && user.jiraUser.link" ngbTooltip="{{'jiraUsers.permission' | translate}}"
                placement="top" container="body" triggers="hover" tooltipClass="apc-tooltip-top"
                [href]="user.jiraUser.link" class="btn modal-btn save" target="_blank">{{'jiraUsers.goto' | translate
                }}</a>
        </div>
    </div>
</div>